module.exports =  {

  whatIsMarketplace: {
    title: '什么是”交易中心“?',
    contents: `
      <p>”交易中心“是交易代币的页面。在这里您可以查看挂单簿，也可以挂单或吃单。挂单簿是以”交易对“的形式呈现的，每一个交易对包括一个卖出代币和一个买入代币。您可以从”热门交易对“中选择交易对，也可以通过使用”我关注的交易对“来添加新的交易对。</p>
    `,
  },

  howToAddTradingPair: {
    title: '如何添加新的交易对？',
    contents: `
      <p>LedgerDex支持所有ERC20代币之间的交易，用户可以自行添加任意交易对，”上币“不需要通过我们的允许。</p>
      <p>若要添加新的交易对，您可以进入”交易中心“页面，点击”我关注的交易对“下面的”添加交易对“按钮。</p>
      <p>添加交易对时，您可以从下拉列表中选择用于购入和卖出的代币，这个列表中的选项包括您已关注的代币以及
      一些热门代币。如果选项中没有您想要的代币，您可以点击”+添加新的代币“来添加。新添加的代币也将同时被加入您关注的代币列表中。
    `,
  },

 howToReadOrders: {
    title: '如何读懂订单？',
    contents: `
      <p>对于每个交易对，您可以看到两组订单：”卖出单“和”买入单“。”卖出单“出现在页面上部，”买入单“在页面下部，二者之间可以看到买入价格和卖出价格的差价。</p>
       <p>例如，对于”ZRX - WETH“交易对，”卖出单“（页面上部）包含了卖出ZRX、买入WETH的挂单，”买入单“（页面下部）包含了卖出WETH、买入ZRX的挂单。每一组挂单都是按照价格排列的，一般来说，越靠近中间的挂单对于吃单者在价格上越具吸引力。</p>
      <p>对于每一个挂单，您可以点击”吃单“按钮来吃单。吃单的条件是您拥有相应代币并已事先添加对于该代币的交易授权。</p>
      <p>您也自己可以创建新挂单（等待别人吃单）——点击”创建挂单“即可。.</p>
    `,
  },

  howToTrade: {
    title: '如何交易？',
    contents: `
      <p>假设您想要把自己的一部分ZRX代币通过交易兑换成WETH代币，换句话说，您想要卖出ZRX、买入WETH。您可以通过以下两种方式来实现交易：</p>
      <ul class="mb-2">
        <li><strong>方法一: 找到一个合适的挂单来吃单</strong>：查看”交易中心“中的”WETH - ZRX“挂单（卖出WETH、买入ZRX），如果其中有令您满意的挂单，您可以通过吃单的方式与挂单者交易。在这种情况下，您是交易中的<strong>”吃单者“（Taker)</strong>。</li>
        <li><strong>方法二：创建新挂单，等待他人吃单</strong>：您自己创建卖出ZRX、买入WETH的新挂单。其他交易者看到您的挂单后有可能会通过吃单的方式和您交易。在这种情况下您是交易中的<strong>”挂单者“（Maker）</strong>。</li>
      </ul>
    `,
  },

  isPartialFillPossible: {
    title: '吃单时可以只买入挂单数量的一部分吗？',
    contents: `
      <p>可以的，吃单者不需要交易挂单的全部代币数量。对于一个卖出1000个X代币、买入2000个Y代币的挂单，吃单者可以交易小于2000的Y代币，例如，可以在吃单时买入1500个Y代币，获得750个X代币。
      </p>
    `,
  },

  feeForCreateOrder: {
    title: '挂单者（Maker）需要交多少手续费？',
    contents: `
      <p>当您创建并提交新挂单时，您并不需要付任何交易费，也不需要付以太坊矿工费（Gas），这是因为您的挂单是在链下存储的，创建挂单不涉及链上交易。</p>
      <p>如果交易所收取<strong>挂单手续费（Maker Fee）</strong>, 这笔费用只有在交易完成（有人吃单）后才会被扣除。如果最终没人吃单，挂单者也不会被扣费。当您创建挂单时，会有一个”检查挂单“的步骤，这时您能清楚地看到这笔交易是否有挂单费。如果挂单只被吃掉一部分，那么挂单费（如有）也只会扣除相应的一部分。</p>
      <p>当您的挂单发生吃单交易时，会发生链上交易，但这时的矿工费（Gas）是由吃单着（Taker）交付的，而不是您（挂单者）。</p>
    `,
  },

  feeForFillOrder: {
    title: '吃单者（Taker）需要交多少手续费？',
    contents: `
      <p>当您查看一笔挂单时，您可以看到这一挂单是否有<strong>吃单手续费（Taker Fee）</strong>。如果存在吃单手续费，这笔费用会在交易成功后从吃单者的代币余额中扣除。如果只是部分吃单（吃掉挂单总量的一部分），吃单手续费的数额也会按比例只收取总额的一部分。</p>
      <p>吃单者在吃单时还需缴纳一笔<strong>协议费（Protocol Fee）</strong>。协议费（ETH或WETH）的数额和吃单时的以太坊矿工费相关，每笔交易的协议费计算公式是150,000乘以当前矿工费。</p>
      <p>因为吃单的过程涉及以太坊链上交易，吃单者还需要支付以太坊矿工费（Gas），这笔费用不是给交易所的。
      </p>
    `,
  },

}

